import { render } from "./CopdPatientsTable.vue?vue&type=template&id=046f395e&ts=true"
import script from "./CopdPatientsTable.vue?vue&type=script&lang=ts"
export * from "./CopdPatientsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__